{
    "LinkInput_Title": "Titre",
    "LinkInput_URL": "URL",
    "LinkInput_Target": "Cible",
    "LinkInput_NewTab": "Ouvrir dans un nouvel onglet",
    "LinkInput_CurrentTab": "Ouvrir dans l'onglet actuel",
    "NAME": "LinkInputLanguage"
}